module.exports = __webpack_public_path__ + "static/media/huddersfield.fb6c5a61.png";